function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    width: "36px",
    height: "36px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "scale(0.8)"
    }
  }, React.createElement("g", {
    className: "ldl-ani"
  }, React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.598291s infinite normal forwards running breath"
    }
  }, React.createElement("circle", {
    fill: "#ffdc6c",
    clipRule: "evenodd",
    fillRule: "evenodd",
    r: 21.4,
    cy: 50,
    cx: 50,
    style: {
      fill: "rgb(255, 220, 108)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.641026s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M50 10v11.8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.683761s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M30 15.4l5.9 10.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.726496s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M15.4 30l10.2 5.9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.769231s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M10 50h11.8",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.811966s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M15.4 70l10.2-5.9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.854701s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M30 84.6l5.9-10.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.897436s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M50 90V78.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.940171s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M70 84.6l-5.9-10.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -0.982906s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M84.6 70l-10.2-5.9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.02564s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M90 50H78.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.06838s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M84.6 30l-10.2 5.9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))), React.createElement("g", {
    className: "ldl-layer"
  }, React.createElement("g", {
    className: "ldl-ani",
    style: {
      transform: "scale(0.91)",
      transformOrigin: "50px 50px",
      animation: "1.11111s linear -1.11111s infinite normal forwards running breath"
    }
  }, React.createElement("path", {
    d: "M70 15.4l-5.9 10.2",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeWidth: 4.588,
    stroke: "#f8b26a",
    fill: "none",
    style: {
      stroke: "rgb(248, 178, 106)"
    }
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.cc04b1fa.svg";
export { ForwardRef as ReactComponent };